<template>
  <div v-if="enabled == true" class="row">
    <!--  mt-4 mb-4 pt-4 pb-3 form-base -->
    <!-- <b-form
      class="col-md-12"
      ref="frmBasicData"
      @submit.stop.prevent="createDiscount"
    >
      <div class="row">
        <div class="col-md-6">
          <my-input
            id="discount-code"
            name="discount-code"
            label="Discount Code"
            placeholder="UseMefor50bucksOff!"
            inlinerows="false"
            classes="bg-gray"
            ref="discountCode"

            v-model="stateCoupon.discountCode"
            :error="v$.discountCode.$error == true ? v$.discountCode.$errors[0].$message : ''"
          ></my-input>
        </div>
        <div class="col-md-3">
          <selector
            id="type-sel"
            name="type-sel"
     
            label="Value"
            placeholder=""
            :data="discountOptions"
            valuefield="type_id"
            textfield="type_name"
            inlinerows="false"
            classes="bg-gray"
            blockClasses=""
            blockLabelClass="col-md-12 pl-0 pr-0"
            ref="selectedDiscount"
            v-model="stateCoupon.selectedDiscount"
            :error="v$.selectedDiscount.$error == true ? v$.selectedDiscount.$errors[0].$message : ''"
          ></selector>
        </div>
        <div class="col-md-3 d-flex align-items-end mb-3">
          <my-button
            fa="percent"
            fapos="left"
            label="Set Discount"
            variant="solid-primary"
            classes="pl-4 pr-4"
            height="48px"
            width="100%"
          type="submit"
          ></my-button>
        </div>
      </div>
    </b-form> -->
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { reactive } from "@vue/composition-api";

// import MyInput from "../atoms/Input.vue";
// import MyButton from "../atoms/Button.vue";
// import Selector from "../atoms/Selector.vue";

export default {
  name: "discount",
  async created() {
    // const result = await this.$store.dispatch("getAllCoupons");
    // this.discounts = result;
  },
  setup() {
    const stateCoupon = reactive({
      discountCode: "",
      selectedDiscount: "",
    });

    const rulesCoupon = {
      discountCode: { required },
      selectedDiscount: { required },
    };

    const v$ = useValidate(rulesCoupon, stateCoupon);

    return {
      stateCoupon,
      v$,
    };
  },
  data() {
    return {
      discountCode: "",
      discounts: [],

      discountOptions: [
        { type_id: "percent_off-50", type_name: "50% Off" },
        { type_id: "amount_off-10", type_name: "10 SEK Off" },

        { type_id: "percent_off-10", type_name: "10% Off" },
        { type_id: "amount_off-5", type_name: "5 SEK Off" },

        { type_id: "percent_off-12", type_name: "12% Off" },
        { type_id: "amount_off-1", type_name: "1 SEK Off" },
      ],
    };
  },
  props: {
    enabled: {
      default: false,
    },
  },
  methods: {
    async createDiscount() {
      this.v$.$validate();
      // console.log(this.v$);
      if (!this.v$.$error) {
        const params = {
          coupon: {
            promo_code: this.stateCoupon.discountCode,
            type: this.stateCoupon.selectedDiscount.split("-")[0],
            off_amount: this.stateCoupon.selectedDiscount.split("-")[1],
          },
          percent_off: "25.3",
          // amount_off: "10",
          // duration: "once", // 'once, repeating, forever'
          // duration_in_months = 3,
        };

        await this.$store
          .dispatch("createCoupon", params)
          .then((result) => {
            result = JSON.parse(JSON.stringify(result));

            console.log(result);

            this.$fire({
              title: "Discount Code Status",
              text: "Creation Discount Code was a success",
              type: "success",
              html: "",
              timer: 3000,
            }).then(() => {});
          })
          .catch((error) => {
            this.$fire({
              title: "Discount Code Status",
              text: "Creation Discount Code was a failure",
              type: "error",
              html: "<div>" + error + "</div>",
              timer: 3000,
            }).then(() => {
              //this.$router.push({ name: "CompanyMakePaymentFail" });
            });
          });
      }
    },
  },
  components: {
    // MyInput,
    // MyButton,
    // Selector,
  },
};
</script>
